import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { HistoryEntryIcon, HistoryEntryMainText, HistoryItemProps, UserInfoDisplay } from "./common";

export const HistoryItemDefault = ({
  item,
  statusesConfig,
}: HistoryItemProps) => {
  return (
    <>
      <HistoryEntryIcon>
        <InfoOutlinedIcon sx={{ height: 20, color: "#757575" }} />
      </HistoryEntryIcon>

      <HistoryEntryMainText>Event</HistoryEntryMainText>

      <UserInfoDisplay item={item} statusesConfig={statusesConfig} />
    </>
  );
};
